export enum SeniorityLevel {
  Junior = 'Junior',
  Middle = 'Middle',
  Senior = 'Senior',
}
